<template>
  <base-frame :isMe="isMe" :sendType="msgObj.msgStatus" class="w100">
      <div slot="chatmessage">
        {{msgObj.content.txt}}
        <question-list :msgid="msgObj.msgid" :questions="msgObj.content.questions" :tipTxt="msgObj.content.tipTxt"  :showRefresh="msgObj.content.showRefresh"/>
      </div>
  </base-frame>
</template>



<script>
import BaseFrame from './BaseFrame'
import QuestionList from './QuestionList'

export default {
  name: 'tpl-qs-list',
  components: {
    BaseFrame,
    QuestionList
  },
  props: {
    msgObj: Object,
    isMe: Boolean
  }
}
</script>






// WEBPACK FOOTER //
// src/components/templates/TplQsList.vue